export const lazyLoadSettings = {
  class_loading: 'lazy--loading',
  class_loaded: 'lazy--loaded',
  class_entered: 'lazy--entered',
  class_error: 'lazy--error',
};
